const viewAny = (permissions) => {
  return permissions.includes('read-countries')
}

const create = (permissions) => {
  return hasPermission(permissions, 'access-counties')
}

const update = (permissions) => {
  return hasPermission(permissions, 'access-counties')
}

const deletee = (permissions) => {
  return hasPermission(permissions, 'delete-counties')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};